import(/* webpackMode: "eager" */ "C:\\Users\\User\\Documents\\PROJECT 4\\magikalcandy\\src\\app\\not-found.tsx");
